<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/parameters"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Βήματα Πληρωμών</u></h4>
        </div>
      </div>

      <div>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        @initialized="saveGridInstance"
        :data-source="actions"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        :show-row-lines="true"
        :row-alternation-enabled="true"
      >
        <DxPaging :page-size="20" />
        <DxEditing mode="cell" :use-icons="true" />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />

        <DxColumn
          caption="Id"
          data-field="Id"
          data-type="integer"
          :visible="false"
        >
        </DxColumn>

        <DxColumn
          caption="#"
          data-field="SortOrder"
          data-type="integer"
          alignment="center"
          width="80px"
        >
        </DxColumn>

        <DxColumn
          caption="Περιγραφή"
          data-field="Description"
          data-type="string"
          alignment="left"
          width="300px"
        >
        </DxColumn>

        <DxColumn
          caption="Download"
          data-field="HasDownload"
          data-type="boolean"
          width="120px"
          alignment="center"
        >
        </DxColumn>

        <DxColumn
          caption="Upload"
          data-field="HasUpload"
          data-type="boolean"
          width="100px"
          alignment="center"
        >
        </DxColumn>

        <DxColumn
          caption="WebService"
          data-field="HasWebService"
          data-type="boolean"
          width="130px"
          alignment="center"
        >
        </DxColumn>

        <DxColumn
          caption="Έλεγχος Ψηφ. Υπογρ."
          data-field="CheckForSignature"
          data-type="boolean"
          width="150px"
          alignment="center"
        >
        </DxColumn>

        <DxColumn
          caption="Αλλαγή Ημ/νίας Λήξης"
          data-field="CanChangeValidUntil"
          data-type="boolean"
          width="130px"
          alignment="center"
        >
        </DxColumn>

        <DxColumn
          caption="Ενεργό"
          data-field="IsActive"
          data-type="boolean"
          width="100px"
          alignment="center"
        >
        </DxColumn>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxRequiredRule,
  DxFilterRow,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    BackButton,
    DxLoadIndicator,
  },
  data() {
    return {
      actions: [],
      dataGridInstance: null,
      loadIndicatorVisible: false,
    };
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },

    async getActions() {
      const res = await mainService.get("/Actions/GetActions");
      this.actions = res.data;
    },
  },
  computed: {},
  watch: {},

  async mounted() {
    this.loadIndicatorVisible = true;
    this.getActions();
    this.loadIndicatorVisible = false;
  },
};
</script>

  <style scoped>
.dx-overlay-wrapper {
  max-width: 100px !important;
}

.dx-toast-message {
  width: 100px !important;
}
</style>